/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sidebar_DescriptionInputs */

const en_common_sidebar_description = /** @type {(inputs: Common_Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Displays the mobile sidebar.`)
};

const es_common_sidebar_description = /** @type {(inputs: Common_Sidebar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestra la barra lateral movil.`)
};

/**
* | output |
* | --- |
* | "Displays the mobile sidebar." |
*
* @param {Common_Sidebar_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_sidebar_description = /** @type {((inputs?: Common_Sidebar_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sidebar_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sidebar_description(inputs)
	return es_common_sidebar_description(inputs)
});